import type { SessionStore } from './SessionStore'

/**
 * Mount the store's public view on `window._alegraApp.stores.session` as a
 * non-writable, non-configurable property. Idempotent — if a session handle
 * is already installed (e.g. an earlier copy of the runtime got there first),
 * this is a no-op.
 *
 * Only the CDN entry calls this; orchestrators and microfronts never need
 * it.
 */
export function installOnWindow(store: SessionStore): void {
  window._alegraApp ??= {}
  window._alegraApp.stores ??= {}
  if (window._alegraApp.stores.session) return
  Object.defineProperty(window._alegraApp.stores, 'session', {
    value: store.publicView(),
    writable: false,
    configurable: false,
    enumerable: true,
  })
}
